define('views/modules/setting/business/blocks/custom-data/custom-data',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // collections
    'collections/calendar/personal-data/personal-data-types',
    // views
    'views/parts/info-section',
    'views/modules/calendar/personal-data/manager/personal-data-manager-panel',
    // templates
    'text!templates/modules/setting/business/blocks/custom-data/custom-data.html'

], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // collections
    CPersonalDataTypes,
    // views
    VInfoSection,
    VPersonalDataManagerPanel,
    // templates
    TCustomData
) {

    var VCustomData = Backbone.Epoxy.View.extend({
        template: TCustomData,

        regions: {
            count: '.count',
            datas: '.datas'
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.collection = new CPersonalDataTypes();

            this.view = {
                info: new VInfoSection({
                    title: "Your custom data",
                    icon: "sl-icon-settings",
                    //help: "messages:helpbox-business-custom-data-view",
                    buttonBottom: {
                        text: "Manage my custom data",
                        context: this,
                        callback: this.onManageCustomData
                    },
                    content: this.template,
                }),
            };

            this.listenTo(this.collection, { 'sync': this.onCollectionSync });
        },

        render: function() {
            this.assign(this.view.info, this.$el) // must be first
                .applyBindings();

            this.generateZones();
            this.collection.fetch();

            return this;
        },

        _renderCount: function() {
            this.zone.$count.html(this.collection.length);
        },

        ////////////
        // events //
        ////////////

        onCollectionSync: function(collection, options) {
            this._renderCount();
        },

        onManageCustomData: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.manager || (view.manager = new VPersonalDataManagerPanel({ model: this.model, }));
            this.trigger('panel:stack', panel);
        },

    });

    return VCustomData;
});

